import React from 'react'

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      setModal // via redux actions
    } = props

    const handleClickDismiss = event => {
      // close modal so it won't be open when we return
      setModal({ open: false })
    }

    return <WrappedComponent onClickDismiss={handleClickDismiss} {...props} />
  }
}

export default withEventHandlers
